import i18n from "i18next";
import {initReactI18next} from "react-i18next";

import header_fr from "./translations/fr/header.json";
import header_en from "./translations/en/header.json";
import login_en from "./translations/en/login.json";
import login_fr from "./translations/fr/login.json";
import footer_en from "./translations/en/footer.json";
import footer_fr from "./translations/fr/footer.json";
import assessment_fr from "./translations/fr/assessment.json";
import assessment_en from "./translations/en/assessment.json";
import propertySelectionList_fr from "./translations/fr/propertySelectionList.json";
import propertySelectionList_en from "./translations/en/propertySelectionList.json";
import property_en from "./translations/en/property.json";
import property_fr from "./translations/fr/property.json";
import profile_en from "./translations/en/profile.json";
import profile_fr from "./translations/fr/profile.json";
import toc_en from "./translations/en/toc.json";
import toc_fr from "./translations/fr/toc.json";
import nbhd_en from "./translations/en/nbhd.json";
import nbhd_fr from "./translations/fr/nbhd.json";
import landing_en from "./translations/en/landing.json";
import landing_fr from "./translations/fr/landing.json";
import rfr_en from "./translations/en/rfr.json";
import rfr_fr from "./translations/fr/rfr.json";
import faq_en from "./translations/en/faq.json";
import faq_fr from "./translations/fr/faq.json";
import enotif_en from "./translations/en/enotif.json";
import enotif_fr from "./translations/fr/enotif.json";
import enotifdisabled_en from "./translations/en/enotifdisabled.json";
import enotifdisabled_fr from "./translations/fr/enotifdisabled.json";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
        en: {
            header: header_en,
            login: login_en,
            assessment: assessment_en,
            landing: landing_en,
            propertySelectionList: propertySelectionList_en,
            property: property_en,
            footer: footer_en,
            rfr: rfr_en,
            profile: profile_en,
            nbhd: nbhd_en,
            faq: faq_en,
            toc: toc_en,
            enotif: enotif_en,
            enotifdisabled: enotifdisabled_en
        },
        fr: {
            header: header_fr,
            login: login_fr,
            assessment: assessment_fr,
            landing: landing_fr,
            propertySelectionList: propertySelectionList_fr,
            property: property_fr,
            footer: footer_fr,
            rfr: rfr_fr,
            profile: profile_fr,
            nbhd: nbhd_fr,
            faq: faq_fr,
            toc: toc_fr,
            enotif: enotif_fr,
            enotifdisabled: enotifdisabled_fr
        },
    },
    lng: localStorage.getItem("prefLang") || "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
});

export default i18n;
